<script setup lang="ts">
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useRouter } from "vue-router";

import { MatomoHelper, SearchRouteHelper } from "@/helpers";
import { useSearchStore, useSuggestionsStore, useUserStore } from "@/stores";
import { MatomoEventAction, MatomoEventCategory, type SearchFilter } from "@/types";

const { userData } = storeToRefs(useUserStore());
const searchStore = useSearchStore();
const searchRouteHelper = new SearchRouteHelper(useRouter(), userData);

const { suggestions } = storeToRefs(useSuggestionsStore());
const { getSuggestions, storeSuggestionSelection: logSelectedSuggestion } = useSuggestionsStore();

const freeSearchesLeft = computed<number | null>(() => userData.value.freeSearchesLeft);

const searchWithSearchFilter = (
  searchQuery: string,
  filter: SearchFilter,
  dictionaryId?: string,
  allowSwitchDictionary = true
) => {
  const matomoAction = filter.sourceLanguage
    ? MatomoEventAction.SearchWithLanguageSelector
    : MatomoEventAction.SearchWithoutLanguageSelector;

  const withWithout = filter.sourceLanguage ? "with" : "without";

  MatomoHelper.sendEvent(
    MatomoEventCategory.Search,
    matomoAction,
    `Made a search ${withWithout} an active language selector`
  );

  searchRouteHelper.searchWithSearchFilter(searchQuery, filter, dictionaryId, allowSwitchDictionary);
};
</script>

<template>
  <slot
    v-bind="{
      query: searchStore.query,
      suggestions,
      selectedDictionaryId: searchStore.selectedDictionaryId,
      prioritizedMethodIds: searchStore.prioritizedMethodIds,
      selectedMethodIds: searchStore.selectedMethodIds,
      isLoading: searchStore.isLoading,
      freeSearchesLeft,
      searchWithSearchFilter,
      getSuggestions,
      logSelectedSuggestion
    }"
  />
</template>
